export enum ROUTE {
  Home = "/",
  Login = "/login",
  CreateEvent = "/create-event",
  EditEvent = "/edit-event",
  DiscountManagement = "/discount-management",
  CreateDiscount = "/create-discount",
  EditDiscount = "/edit-discount",
  ReferralPoints = "/referral-points",
  BookingPoints = "/booking-points",
  Refund = "/refund",
  FlightDiscountManagement = "/flight-discount-management",
  CreateFlightDiscount = "/create-flight-discount",
  EditFlightDiscount = "/edit-flight-discount",
  RefundFlight = "/refund-flight",
}
